<div class="modal-header">
  <div>
    <h2 mat-dialog-title style="font-size: 18px !important;">Notificaciones</h2>
  </div>
  <button (click)="onClose()">
    <span>Cerrar</span>
    <img src="assets/img/icon-cerrar-blue.svg" alt="Cerrar">
  </button>
</div>

<div mat-dialog-content class="modal-body" style="padding: 0;">
  <ng-container *ngIf="notifications.length > 0; else sinNotificaciones">
    <div
      class="notification-item"
      [class.notification-unread]="!notif.read"
      *ngFor="let notif of notifications"
      (click)="onMarkRead(notif)"
      style="cursor: pointer;"
    >
      <div class="row">
        <div class="col-8">
          <h2 style="font-size: 14px !important; color: #1D2345; font-weight: 600;">
            {{ notif.title }}
          </h2>
        </div>
        <div class="col-4" style="text-align: end;">
          <span style="color: #ABA7AF;">{{ notif.sentAt | date: 'dd/MM/yy HH:mm' }}</span>
        </div>
      </div>
      <p style="margin-bottom: 0.5rem;">{{ notif.description }}</p>
    </div>
  </ng-container>

  <ng-template #sinNotificaciones>
    <div class="d-flex flex-column align-items-center justify-content-center" style="height: 200px; color: #ABA7AF;">
      <img src="assets/img/icon-notification.svg" alt="Sin notificaciones" width="40" style="opacity: 0.3; margin-bottom: 12px;">
      <span>No hay notificaciones</span>
    </div>
  </ng-template>
</div>
